import { makeStyles } from '@mui/styles';
const expressionsOfInterestWrapperSideStyles = makeStyles(() => ({
    container: {
        width: '100%',
        padding: '20px 0',
    },
}), { name: 'Common_ExpressionsOfInterestWrapperSide' });
export default expressionsOfInterestWrapperSideStyles;
//# sourceMappingURL=expressionsOfInterestWrapperSide.styles.js.map